<div class="d-flex align-items-center">
  <div class="" style="width: 300px;">
    <ng-container>
      <ng-select
        class="form-control"
        [formControl]="period"
        [items]="periods"
        bindLabel="period"
        placeholder="{{ 'timefilter_dates_choose' | translate }}"
        (change)="onSelectionChange($event)"
      ></ng-select>
    </ng-container>
  </div>
  <span class="ms-5" translate>common_from</span>
  <wsb-atlas-datepicker [formControl]="dateFrom" [max]="dateTo.value ? dateTo.value : today" class="ms-3"></wsb-atlas-datepicker>
  <span class="ms-5" translate>common_to</span>
  <wsb-atlas-datepicker [min]="dateFrom.value" [max]="today" class="ms-3" [formControl]="dateTo"></wsb-atlas-datepicker>
  <wsb-atlas-button
    class="ms-5"
    [label]="'common_search'"
    [disabled]="!dateFrom.value || !dateTo.value"
    [variant]="'primary'"
    (click)="search()"
  >
  </wsb-atlas-button>
</div>

<div class="mt-5 mb-5 d-flex mt-5">
  <div class="text-center">
    <span class="icon-custom-height" [inlineSVG]="'assets/images/icons/icon-desktop.svg'"></span>

    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutDesktopData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ percDesktop ? percDesktop : 0 }}%</div>
      </div>
      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_desktop</div>
        <div class="text-center clicks mt-2">{{ totalDesktop ? totalDesktop : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>

  <div class="text-center">
    <span class="icon-custom-height" [inlineSVG]="'assets/images/icons/icon-smartphone.svg'"></span>
    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutSmartphoneData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ percSmartphone ? percSmartphone : 0 }}%</div>
      </div>
      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_smartphone</div>
        <div class="text-center clicks mt-2">{{ totalSmartphone ? totalSmartphone : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>

  <div class="text-center">
    <span class="icon-custom-height" [inlineSVG]="'assets/images/icons/icon-tablet.svg'"></span>
    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutTabletData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ percTablet ? percTablet : 0 }}%</div>
      </div>

      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_tablet</div>
        <div class="text-center clicks mt-2">{{ totalTablet ? totalTablet : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>

  <div>
    <div class="d-flex flex-row justify-content-center" style="height: 140px;">
      <div class="d-flex flex-column justify-content-between">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-tv.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-camera.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-music.svg'"></span>
      </div>

      <div class="d-flex flex-column justify-content-between">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-car.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-phone.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-gamepad.svg'"></span>
      </div>
    </div>
    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutOthersData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ percOther ? percOther : 0 }}%</div>
      </div>
      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_other</div>
        <div class="text-center clicks mt-2">{{ totalOther ? totalOther : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>
</div>

<div class="">
  <table class="table">
    <thead>
      <tr>
        <th translate>stats_pages_details_device_title</th>
        <th class="text-center" translate>stats_pages_details_device_views</th>
        <th class="text-end" translate>common_percent</th>
      </tr>
    </thead>
    <tbody *ngIf="landingDeviceStats && landingDeviceStats['operating-system']">
      <tr *ngFor="let os of landingDeviceStats['operating-system']">
        <td class="left-column">{{ os.resource }}</td>
        <td class="center-column views">{{ os.statistics.total }}</td>
        <td class="right-column">{{ osPerc(os.statistics.total) }}%</td>
      </tr>
    </tbody>
  </table>
</div>
